import React from "react";
import { Svg } from "./styles";

const Rectangle = ({ size = 60 }) => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 22 22`}
    >
      <path d="M22 0h-22v22h22v-22z" />
    </Svg>
  );
};

export default Rectangle;
